import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { BRAND } from "@/lib/brand";

const formatErr = (d) => {
    if (!d) return "Erro inesperado.";
    if (typeof d === "string") return d;
    if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" ");
    return d.msg || JSON.stringify(d);
};

export default function AdminLogin() {
    const { user, login } = useAuth();
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);

    if (user) return <Navigate to="/admin" replace />;

    const onSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await login(email.trim().toLowerCase(), password);
            toast.success("Sessão iniciada.");
            navigate("/admin", { replace: true });
        } catch (err) {
            toast.error(formatErr(err?.response?.data?.detail) || "Credenciais inválidas.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-beige-50 flex items-center justify-center px-6 py-16">
            <div className="w-full max-w-md">
                <div className="text-center mb-10">
                    <img
                        src={BRAND.logo}
                        alt={BRAND.name}
                        className="h-20 w-20 mx-auto object-contain"
                    />
                    <div className="mt-4 font-serif text-2xl text-stone-900">{BRAND.name}</div>
                    <div className="text-xs uppercase tracking-[0.24em] text-stone-500 mt-1">
                        Painel de Gestão
                    </div>
                </div>
                <form
                    onSubmit={onSubmit}
                    className="bg-white rounded-2xl ring-1 ring-stone-200 p-8 md:p-10 shadow-sm space-y-5"
                    data-testid="admin-login-form"
                >
                    <h1 className="font-serif text-3xl text-stone-900">Entrar</h1>
                    <p className="text-sm text-stone-500 -mt-2">
                        Acesso restrito.
                    </p>
                    <div>
                        <Label htmlFor="email" className="text-stone-700 text-sm">Email</Label>
                        <Input
                            id="email"
                            type="email"
                            data-testid="login-email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="mt-1.5 bg-stone-50 border-stone-200 focus-visible:ring-0 focus-visible:border-stone-900 h-12 rounded-lg"
                            placeholder="o seu email"
                            required
                        />
                    </div>
                    <div>
                        <Label htmlFor="password" className="text-stone-700 text-sm">Password</Label>
                        <Input
                            id="password"
                            type="password"
                            data-testid="login-password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="mt-1.5 bg-stone-50 border-stone-200 focus-visible:ring-0 focus-visible:border-stone-900 h-12 rounded-lg"
                            placeholder="••••••••"
                            required
                        />
                    </div>
                    <Button
                        type="submit"
                        disabled={loading}
                        className="w-full rounded-full bg-stone-900 hover:bg-stone-800 text-stone-50 py-6 h-auto"
                        data-testid="login-submit"
                    >
                        {loading ? "A entrar…" : "Entrar"}
                    </Button>
                </form>
                <div className="text-center mt-6">
                    <a href="/" className="text-sm text-stone-500 hover:text-stone-900 link-underline">
                        ← Voltar ao site
                    </a>
                </div>
            </div>
        </div>
    );
}
